// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const attributionClient = createTypedClient();
export const createAttributionClient = (config) => createTypedClient(config);
